import { Component, OnInit } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { FieldType, FormlyModule } from '@ngx-formly/core';

@Component({
  standalone: true,
  imports: [MatExpansionModule, FormlyModule],
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
`],
  template: `
    <div class="card">
      <label class="card-header"><strong>{{ props.label }}</strong></label>
      <div class="card-body mb-2">
        @for (field of field.fieldGroup; track field) {
          <formly-field [field]="field" />
        }
      </div>
    </div>
  `,
})
export class AdvancedOptionWrapperComponent extends FieldType {}